const stateActions = {
  setSystemData: ({ commit }, systemData) => {
    commit('setSystemData', systemData);
  },

  restoreSystemData: ({ commit }) => {
    const systemData = JSON.parse(sessionStorage.getItem('systemData'));
    commit('setSystemData', systemData);
  }
};

export default {
  ...stateActions
};
